if (!customElements.get('g-localization-form')) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select &&
        select.addEventListener('change', (e) => {
          const value = e.target.value;
          const form = select.closest('[data-localization-form]');
          const localeInput = form.querySelector('input[name="locale_code"]');
          const countryInput = form.querySelector('input[name="country_code"]');

          // 更新区域设置代码值
          if (localeInput) localeInput.setAttribute('value', value);
          if (countryInput) countryInput.setAttribute('value', value);

          // 获取当前 URL
          const currentUrl = new URL(window.location.href);

          // 获取路径部分并移除前后的斜杠
          let pathname = currentUrl.pathname.replace(/^\/|\/$/g, '');

          // 分割路径为数组
          let pathSegments = pathname.split('/');

          // 过滤掉语言代码部分
          pathSegments = pathSegments.filter(segment => !/^[a-z]{2}(-[a-z]{2})?$/i.test(segment));

          // 重新组合路径
          let updatedPathname = '/' + pathSegments.join('/');

          // 构建新的 URL
          currentUrl.pathname = updatedPathname;

          // 如果 locale 和 country 都是 EN，移除语言路径部分并跳转
          if (localeInput?.value.toUpperCase() === 'EN' && countryInput?.value.toUpperCase() === 'EN') {
            const cleanUrl = currentUrl.toString();
            const finalUrl = new URL(cleanUrl);
            finalUrl.searchParams.delete('country');
            window.location.href = finalUrl.toString();
          } else {
            // 使用 fetch 提交，阻止 Shopify 302 跳转追加 ?country=XX
            const formData = new FormData(form);
            fetch(form.action, { method: 'POST', body: formData })
              .then(function(res) {
                if (res.redirected) {
                  const finalUrl = new URL(res.url);
                  finalUrl.searchParams.delete('country');
                  window.location.href = finalUrl.toString();
                } else {
                  window.location.reload();
                }
              })
              .catch(function() {
                window.location.reload();
              });
          }
        });
    }
  }
  customElements.define('g-localization-form', MLocalizationForm);
}
